import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, []);
  const resendInvoiceVendor = `resendInvoiceVendor(input: ${dataCreate})`;
  return gql`
  mutation {
    ${resendInvoiceVendor} {
      id
    }
  }
`;
};
